module.exports = __webpack_public_path__ + "media/images/no_image-dfe80da620a62a74884151b391f4f47d.svg";